.saved-time{display:flex;height:100%;width:auto;align-items:center;justify-content:flex-end;gap:10px}.saved-time__label{font-weight:700}.rdo-selector__time{font-weight:400;margin-right:5px}
/*# sourceMappingURL=last-saved-time.component-GYWPBFCI.css.map */
